var numeral = require('numeral');

export const changePrice = (val) => {
    if (val === null || val === undefined) return null;
    return numeral(val).format('0,0[.]00').replace(/,/g, '.');
}

export const getMilesOrMil = (i18n, mil) => {
    // return /tr/.test(i18n.language.toLowerCase()) ? ' Mil' : (parseFloat(mil) === 0 ? ' Mil' : ' Miles');
    return /tr/.test(i18n.language.toLowerCase()) ? ' Mil' : ' Miles';
}
